import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function Suitcase({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 640 640"
      className={iconClass}
      width={width}
    >
      <path fill="currentColor" d="M272 96L368 96C376.8 96 384 103.2 384 112L384 160L256 160L256 112C256 103.2 263.2 96 272 96zM224 112L224 160L128 160C92.7 160 64 188.7 64 224L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 224C576 188.7 547.3 160 512 160L416 160L416 112C416 85.5 394.5 64 368 64L272 64C245.5 64 224 85.5 224 112zM240 192L432 192L432 512L208 512L208 192L240 192zM176 192L176 512L128 512C110.3 512 96 497.7 96 480L96 224C96 206.3 110.3 192 128 192L176 192zM464 512L464 192L512 192C529.7 192 544 206.3 544 224L544 480C544 497.7 529.7 512 512 512L464 512z" />
    </svg>
  );
}
